var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.8 67.28c4.56 0 8.28-1.5 11.16-4.5 2.88-3 4.32-7.02 4.32-12.06 0-4.56-1.5-8.16-4.5-10.8-3-2.64-6.66-3.96-10.98-3.96-.84 0-1.44.06-1.8.18 0-5.4 1.44-9.93 4.32-13.59 2.88-3.66 7.2-6.75 12.96-9.27L28.8-.04C19.2 4.52 12.12 10.25 7.56 17.15 3 24.05.72 32 .72 41c0 8.28 1.59 14.73 4.77 19.35 3.18 4.62 7.95 6.93 14.31 6.93Zm41.662 0c4.56 0 8.28-1.5 11.16-4.5 2.88-3 4.32-7.02 4.32-12.06 0-4.56-1.5-8.16-4.5-10.8-3-2.64-6.66-3.96-10.98-3.96-.84 0-1.44.06-1.8.18 0-5.4 1.44-9.93 4.32-13.59 2.88-3.66 7.2-6.75 12.96-9.27L70.462-.04c-9.6 4.56-16.68 10.29-21.24 17.19-4.56 6.9-6.84 14.85-6.84 23.85 0 8.28 1.59 14.73 4.77 19.35 3.18 4.62 7.95 6.93 14.31 6.93Z","fillRule":"nonzero"}));
}

Quote.defaultProps = {"viewBox":"0 0 77 68"};

module.exports = Quote;

Quote.default = Quote;
